export * from './src/restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.context.js';
